module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/store_images/3_fede1745f7af5827801bece6079e935c.png";